module.exports = __webpack_public_path__ + "img/route_receiver_number_2.71970555.png";